import React from "react";
import { Table } from "@mui/material";

const DSTable = (props: React.ComponentProps<typeof Table>) => {
  return <Table {...props} />;
};

export default DSTable;
